import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { DEVICE_CONNECTION } from './url-constants';

type DeviceConnectionEndpointSpecification = ApiEndpointSpecification;
export const DeviceConnectionEndpointSpecification: DeviceConnectionEndpointSpecification = {
    url: DEVICE_CONNECTION,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'DeviceConnectionRequestParams',
    requestBodySchemaName: 'DeviceConnectionRequestBody',
    okResponseSchemaName: 'DeviceConnectionOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeDeviceConnection = Helpers.makeApiRequestFn<
    Types.DeviceConnectionRequestParams,
    Types.DeviceConnectionRequestBody,
    Types.DeviceConnectionOkResponse
>(DeviceConnectionEndpointSpecification);
